import { render } from "./SaveSalaryDeductionComponent.vue?vue&type=template&id=0e7d7aa0&scoped=true"
import script from "./SaveSalaryDeductionComponent.vue?vue&type=script&lang=js"
export * from "./SaveSalaryDeductionComponent.vue?vue&type=script&lang=js"

import "./SaveSalaryDeductionComponent.vue?vue&type=style&index=0&id=0e7d7aa0&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7d7aa0"]])

export default __exports__